import { ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { Guid } from 'guid-typescript';
import { combineLatest, Observable } from 'rxjs';
import * as shared from '../shared';
import { TotalCostsService } from '../shared';
import { ProjectPreperationService } from './service/project-preperation.service';

@Component({
  selector: 'app-project-preperation-section',
  templateUrl: './project-preperation-section.component.html',
  styleUrls: ['./project-preperation-section.component.scss']
})
export class ProjectPreperationSectionComponent implements OnInit {
  @Input() projectId: Guid;
  @ViewChild('projectPreperationTable') public projectPreperationTable: { startEdit: () => void; };
  products: shared.Product[];
  private internalIsBusy: boolean;
  private projectPreperationSectionInfo: shared.DataInfo<shared.OfferSection>;

  public get isBusy(): boolean {
    return this.internalIsBusy;
  }

  public get hasProjectPreperationSection(): boolean {
    return !!this.projectPreperationSectionInfo.data;
  }

  get projectPreperationSection(): shared.OfferSection {
    return this.projectPreperationSectionInfo.data;
  }

  constructor(
    private service: ProjectPreperationService,
    private totalCostsService: TotalCostsService) {
    this.service.isBusy$.subscribe(isBusy => this.internalIsBusy = isBusy);
    this.projectPreperationSectionInfo = {data: undefined, isNew: false };
  }

  ngOnInit(): void {
    const ppProducts$ = this.service.getProjectPreperationProducts();
    const ppSection$ = this.service.getProjectPreperationSection(this.projectId);
    combineLatest([ppProducts$, ppSection$])
      .subscribe(([ppProducts, ppSection]) => {
        this.products = ppProducts;
        this.projectPreperationSectionInfo.data = ppSection;
        this.totalCostsService.sectionInitialized('projectPreperation');
      });
  }

  initializeSection(): void {
    this.projectPreperationSectionInfo.isNew = true;
    this.projectPreperationSectionInfo.data = {
      id: Guid.create(),
      createdOn: new Date(),
      productRelatedEntries: [],
      customEntries: []
    };
    this.projectPreperationTable.startEdit();
  }

  saveChanges(entriesCollection: shared.EntriesCollection): void {
    const updatedSection = {
      id: this.projectPreperationSectionInfo.data.id,
      createdOn: this.projectPreperationSectionInfo.data.createdOn,
      ...entriesCollection
    };
    shared.saveChanges(this.projectId, updatedSection, this.projectPreperationSectionInfo,
      this.service.addProjectPreperationSection.bind(this.service),
      this.service.updateProjectPreperationSection.bind(this.service));
  }

  discardChanges(): void {
    shared.discardChanges(this.projectPreperationSectionInfo);
  }

  deleteSection(): void {
    shared.remove(this.projectId, this.projectPreperationSectionInfo,
      this.service.deleteProjectPreperationSection.bind(this.service));
  }
}
